import { activityTimeframeConfig } from '../../../../utils/constants';

export const timeframeToAnalyticsValue = (apiValue) => activityTimeframeConfig[apiValue]?.analyticsValue;

export const getFilteredStats = (allData, sportKey, filters, fallbackStatKeys) => {
    if (!allData?.sports?.[sportKey]) { return []; }

    const sportData = allData.sports[sportKey];
    const matchType = filters.matchType || 'Singles';
    const verified = filters.verified || false;
    const timeFrame = filters.timeFrame || 'allTime';

    // API shape: definitions = [{ key, label, order }, ...]
    const definitions = sportData.definitions || [];
    const fallbackMap = {};
    fallbackStatKeys.forEach(sk => { fallbackMap[sk.key] = sk; });

    const orderedKeys = Array.isArray(definitions) && definitions.length > 0
        ? [...definitions]
            .sort((a, b) => a.order - b.order)
            .map(def => ({
                key: def.key,
                title: def.label || def.key,
                mobileTitle: fallbackMap[def.key]?.mobileTitle || def.label || def.key,
            }))
        : fallbackStatKeys.map(sk => ({
            key: sk.key,
            title: sk.title,
            mobileTitle: sk.mobileTitle || sk.title,
        }));

    if (orderedKeys.length === 0) { return []; }

    // API shape: sportData.results = [{ timeframe, matchType, verified, stats[] }, ...]
    const result = (sportData.results || []).find(r => r.timeframe === timeFrame &&
        r.matchType === matchType &&
        r.verified === verified);

    const rankLabel = allData.rankLabel ?? null;

    return orderedKeys.map(({ key, title, mobileTitle }) => {
        const stat = result ? (result.stats || []).find(s => s.key === key) : null;
        return {
            statKey: key,
            title,
            mobileTitle,
            total: stat?.played ?? 0,
            wins: stat?.won ?? 0,
            losses: stat?.lost ?? 0,
            rank: stat?.rank ?? null,
            rankDisplay: stat?.rankDisplay ?? null,
            rankLabel,
        };
    });
};

export const getMatchesPlayedStat = (allData, sportKey, filters, fallbackStatKeys) => {
    const stats = getFilteredStats(allData, sportKey, filters, fallbackStatKeys);
    return stats.find(s => s.statKey === 'matchesPlayed') || null;
};
